import React, { Component } from 'react';
import ElezioniContainer from './containers/ElezioniContainer'
import './elezioni.css';

class Elezioni extends Component {
  render() {
    return (
        <ElezioniContainer />
    );
  }
}

export default Elezioni;



// WEBPACK FOOTER //
// ./src/elezioni/index.js